var helpers = require('./helpers');
var experimentation = require('./experimentation');

module.exports = {
    init: async function () {
        const { StatsigClient, runStatsigAutoCapture } = window.Statsig;

        const $statsig = $('#statsig-data');
        const ipAddress = $statsig.data('ip');
        const environment = $statsig.data('environment');
        const apiKey = $statsig.data('key');
        const isLoggedIn = $statsig.data('loggedin') ? 'TRUE' : 'FALSE';
        const isE2ETestRunning = $statsig.data('ise2etestrunning');
        const isWizardSubSessionSF = window.sf_isWizardSubSession || false;

        const LOGLEVEL = {
            'Warn': 2,
            'Debug': 4
        };

        const defaultUser = {
            ip: ipAddress,
            customIDs: {
                stableID: crypto.randomUUID()

            },
            custom: {
                isInternal: Boolean(helpers.getCookie('INTERNAL_OR_OFFLINE')),
                isLoggedIn: isLoggedIn,
                isWizardSubSessionSF: isWizardSubSessionSF
            }
        };

        const userCookieValue = helpers.getCookie('statsig_user');
        const user = userCookieValue ? JSON.parse(userCookieValue) : {};
        const statsigUser = {
            ...defaultUser,
            ...user,
            custom: {
                ...user.custom,
                ...defaultUser.custom,
            }
        };
        helpers.setStatsigUserCookie(statsigUser);

        const client = new StatsigClient(
            apiKey,
            statsigUser,
            {
                environment: {
                    tier: environment === 'production' ? 'production' : 'staging', // In order to match with modern where it's only staging and production
                },
                logLevel: environment === 'production' ? LOGLEVEL['Warn'] : LOGLEVEL['Debug'],
                networkConfig: {
                    preventAllNetworkTraffic: isE2ETestRunning
                }
            }
        );
        window.nmStatsigClient = client;
        window.nmStatsigApiKey = apiKey;

        helpers.addGTMTracking(client);

        runStatsigAutoCapture(client);

        await client.initializeAsync();

        experimentation.handleExperiments();
    }
};
